

export const asyncRouterMap = [

  {
    path: '/',
    name: 'basic-layout',
    component: () => import('../layout/basic-layout.vue'),
    meta: { permission: ['admin', 'producer', 'vip', 'finance'] },
    redirect: '/device-manage/device-query',
    children: [

      {
        path: '/device-modify',
        name: 'device-modify',
        component: () => import('../views/device-modify.vue'),
        meta: { title: '修改设备', permission: ['admin'] },
      },

      {
        path: '/producer-add',
        name: 'producer-add',
        component: () => import('../views/producer-add.vue'),
        meta: { title: '添加生产者', permission: ['admin'] },
      },

      {
        path: '/producer-query',
        name: 'producer-query',
        component: () => import('../views/producer-query.vue'),
        meta: { title: '查询生产者', permission: ['admin'] },
      },

      {
        path: '/producer-modify',
        name: 'producer-modify',
        component: () => import('../views/producer-modify.vue'),
        meta: { title: '修改生产者', permission: ['admin'] },
      },

      {
        path: '/producer-password',
        name: 'producer-password',
        component: () => import('../views/producer-password.vue'),
        meta: { title: '修改密码', permission: ['admin'] },
      },

      {
        path: '/product-add',
        name: 'product-add',
        component: () => import('../views/product-add.vue'),
        meta: { title: '添加产品', permission: ['admin'] },
      },

      {
        path: '/product-query',
        name: 'product-query',
        component: () => import('../views/product-query.vue'),
        meta: { title: '查询产品', permission: ['admin', 'producer'] },
      },

      {
        path: '/product-modify',
        name: 'product-modify',
        component: () => import('../views/product-modify.vue'),
        meta: { title: '修改产品', permission: ['admin'] },
      },

      {
        path: '/func-add',
        name: 'func-add',
        component: () => import('../views/func-add.vue'),
        meta: { title: '添加功能', permission: ['admin'] },
      },

      {
        path: '/func-query',
        name: 'func-query',
        component: () => import('../views/func-query.vue'),
        meta: { title: '查询功能', permission: ['admin'] },
      },

      {
        path: '/func-modify',
        name: 'func-modify',
        component: () => import('../views/func-modify.vue'),
        meta: { title: '修改功能', permission: ['admin'] },
      },


      {
        path: '/password-modify',
        name: 'password-modify',
        component: () => import('../views/password-modify.vue'),
        meta: { title: '修改密码', permission: ['admin', 'producer', 'vip', 'finance'] },
      },


      {
        path: '/device-manage',
        name: 'device-manage',
        component: () => import('../layout/page-layout.vue'),
        meta: {
          title: '设备管理',
          permission: ['admin', 'producer', 'vip']
        },
        children: [
          {
            path: 'device-query',
            name: 'device-query',
            component: () => import('../views/device-manage/device-query.vue'),
            meta: {
              title: '查询设备',
              permission: ['admin', 'producer', 'vip']
            },
          },

        ]
      },

      {
        path: '/authcode-manage',
        name: 'authcode-manage',
        component: () => import('../layout/page-layout.vue'),
        meta: {
          title: '授权码管理',
          permission: ['admin', 'producer']
        },
        children: [
          {
            path: 'hardware-bind',
            name: 'hardware-bind',
            component: () => import('../views/authcode-manage/hardware-bind.vue'),
            meta: {
              title: '绑定硬件',
              permission: ['admin', 'producer']
            },
          },

          {
            path: 'hardware-unbind',
            name: 'hardware-unbind',
            component: () => import('../views/authcode-manage/hardware-unbind.vue'),
            meta: {
              title: '解绑硬件',
              permission: ['admin', 'producer']
            },
          },

          {
            path: 'query-auth-history',
            name: 'query-auth-history',
            component: () => import('../views/authcode-manage/query-auth-history.vue'),
            meta: {
              title: '查询授权历史',
              permission: ['admin', 'producer']
            },
          },

          {
            path: 'query-auth-pre',
            name: 'query-auth-pre',
            component: () => import('../views/authcode-manage/query-auth-pre.vue'),
            meta: {
              title: '查询预授权',
              permission: ['admin', 'producer']
            },
          },
        ]
      },


      {
        path: '/openid-manage',
        name: 'openid-manage',
        component: () => import('../layout/page-layout.vue'),
        meta: {
          title: 'openid管理',
          permission: ['admin']
        },
        children: [
          {
            path: 'openid-query',
            name: 'openid-query',
            component: () => import('../views/openid-manage/openid-query.vue'),
            meta: {
              title: '查询openid',
              permission: ['admin']
            },
          },

          {
            path: 'openid-add',
            name: 'openid-add',
            component: () => import('../views/openid-manage/openid-add.vue'),
            meta: {
              title: '添加openid',
              permission: ['admin']
            },
          },

          {
            path: 'openid-modify/:openId',
            name: 'openid-modify',
            component: () => import('../views/openid-manage/openid-modify.vue'),
            meta: {
              title: '修改openid',
              permission: ['admin']
            },
          },

          {
            path: 'openid-get',
            name: 'openid-get',
            component: () => import('../views/openid-manage/openid-get.vue'),
            meta: {
              title: '扫码获取openid',
              permission: ['admin']
            },
          },

        ]
      },

      
      {
        path: '/order-invoice-manage',
        name: 'order-invoice-manage',
        component: () => import('../layout/page-layout.vue'),
        meta: {
          title: '订单与发票管理',
          permission: ['admin', 'vip', 'finance', 'producer']
        },
        children: [
          {
            path: 'order',
            name: 'order',
            component: () => import('../views/order-invoice-manage/order.vue'),
            meta: {
              title: '订单管理',
              permission: ['admin', 'vip']
            },
          },
          {
            path: 'invoice',
            name: 'invoice',
            component: () => import('../views/order-invoice-manage/invoice.vue'),
            meta: {
              title: '发票管理',
              permission: ['admin', 'vip', 'finance']
            },
          },

          {
            path: 'invoiceInfo',
            name: 'invoiceInfo',
            component: () => import('../views/order-invoice-manage/invoiceInfo.vue'),
            meta: {
              title: '发票信息管理',
              permission: ['admin', 'vip']
            },
          },
          {
            path: 'invoiceList',
            name: 'invoiceList',
            component: () => import('../views/order-invoice-manage/invoiceList.vue'),
            meta: {
              title: '发票列表',
              permission: ['admin', 'finance']
            },
          },
          {
            path: 'invoiceVerify',
            name: 'invoiceVerify',
            component: () => import('../views/order-invoice-manage/invoiceVerify.vue'),
            meta: {
              title: '发票信息审核',
              permission: ['admin', 'vip', 'finance']
            },
          },
          {
            path: 'authCode',
            name: 'authCode',
            component: () => import('../views/order-invoice-manage/authCode.vue'),
            meta: {
              title: '兑换码',
              permission: ['admin']
            },
          },
          {
            path: 'device-list',
            name: 'device-list',
            component: () => import('../views/order-invoice-manage/device-list.vue'),
            meta: {
              title: '设备列表',
              permission: ['admin']
            },
          },
        ]
      },
    ],


  },

  {
    path: '*', redirect: '/404', permission: ['admin', 'producer', 'vip', 'finance']
  }

]


/**
 * 基础路由
 */
export const constantRouterMap = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue'),
    meta: {
      title: '登录',
    },
  },

  {
    path: '/login-mobile',
    name: 'login-mobile',
    component: () => import('../views/login-mobile.vue'),
    meta: {
      title: '手机入口',
    },
  },

  {
    path: '/anonymity-query/:serialNumber',
    name: 'anonymity-query',
    component: () => import('../views/anonymity-query.vue'),
    meta: {
      title: '串号查询',
    },
  },

  {
    path: '/anonymity-query-mobile/:serialNumber',
    name: 'anonymity-query-mobile',
    component: () => import('../views/anonymity-query-mobile.vue'),
    meta: {
      title: '串号查询',
    },
  },

  {
    path: '/result-checking',
    name: 'result-checking',
    component: () => import('../views/result-checking-mobile.vue'),
    meta: {
      title: '结果校验',
    },
  },

  {
    path: '/a/:serialNumber',
    name: 'a',
    component: () => import('../views/a.vue'),
    meta: {
      title: '跳转中',
    },
  },

  {
    path: '/wxAuth',
    name: 'wxAuth',
    component: () => import('../views/wxAuth.vue'),
    meta: {
      title: 'wx',
    },
  },
  {
    path: '/scanCode',
    name: 'scanCode',
    component: () => import('../views/scanCode.vue'),
    meta: {
      title: '扫码',
    },
  },

  {
    path: '/look-openid',
    name: 'look-openid',
    component: () => import('../views/look-openid.vue'),
    meta: {
      title: '查看openid',
    },
  },

  {
    path: '/404',
    component: () => import('../components/404.vue'),
    meta: {
      title: '404',
    },
  },
];




